import gql from "graphql-tag";

export const GET_OPEN_APPROVALS_LIST = gql`
  query notApprovedList {
    notApprovedList {
      prefixName
      lastName
      firstName
      middleName
      nameSuffix
      orgUnit
      jobClass
      recordCount
      employee
      _id
    }
  }
`;
